'use strict';

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory(root);
    } else if (typeof define !== 'undefined' && define.amd) {
        define('iLocalStorage', [], function () {
            return factory(root);
        });
    } else {
        root.iLocalStorage = factory(root);
    }
})(window || module || {}, function (root) {
    return {
        '_storage': root.localStorage,

        'isSupported': function isSupported() {
            return !!this._storage;
        },

        'set': function set(name, value) {
            if (!name || !this._storage) {
                return false;
            }

            try {
                this._storage.setItem(name, value);
                return !!this._storage.getItem(name);
            } catch (e) {
                return value;
            }
        },

        'get': function get(name) {
            if (!name || !this._storage) {
                return null;
            }

            return this._storage.getItem(name);
        },

        'remove': function remove(name) {
            if (!name || !this._storage) {
                return false;
            }

            this._storage.removeItem(name);

            return true;
        },

        'clear': function clear() {
            if (!this._storage) {
                return false;
            }
            var item = void 0;

            for (item in this._storage) {
                if (this._storage.hasOwnProperty(item)) {
                    this._storage.removeItem(item);
                }
            }

            return true;
        }
    };
});